import { FeathersModel } from './feathersModel'
import { createIntlComparer, DEFAULT_LOCALES } from '../services/utils'

/**
 * BFF shape of `features/assistance/attachments` — a client document attached to an assistance.
 * `id` is the id of the linking row (for available, not yet attached documents it equals `documentId`).
 */
export class AssistanceAttachment extends FeathersModel {
  static serviceName = 'features/assistance/attachments'

  assistanceId: number
  documentId: number
  name: string
  url: string
  mimeType: string

  static readonly intlSortComparer = createIntlComparer(DEFAULT_LOCALES, { sensitivity: 'accent' })

  static sortByName(a: AssistanceAttachment, b: AssistanceAttachment) {
    return AssistanceAttachment.intlSortComparer(a.name, b.name)
  }

  static isPdf(attachment: AssistanceAttachment) {
    return attachment.name.toLowerCase().endsWith('.pdf')
  }
}

export type AssistanceAttachmentsRole = 'assistant' | 'coordinator'
